export default __webpack_public_path__ + "static/media/zip.15241d92.svg";